<template>
  <div class="u-wrap">
    <div class="card">
      <van-form >
         <van-field
          :required="true"
          v-model="model.wechatName"
          label="姓名"
          placeholder="请输入姓名"
          input-align="right"
          readonly
        />
        <van-field
          :required="true"
          v-model="model.idNumber"
          label="身份证号"
          placeholder="请输入身份证号"
          input-align="right"
          readonly
        />
        <van-field
          :required="true"
          v-model="model.phone"
          label="联系电话"
          placeholder="请输入手机号码"
          input-align="right"
          @input="onInput"
          readonly
        />
        <van-field
          v-if="isChange" 
          :required="true"
          v-model="sms"
          center
          clearable
          label="验证码"
          placeholder="请输入短信验证码"

        >
          <template #button>
            <van-button v-if="senMsg_type==1" size="small" type="primary" @click="sendMsg">{{sendTxt}}</van-button>
            <van-button v-if="senMsg_type==2" size="small" type="primary">{{secodes}}s 重新获取</van-button>
          </template>
        </van-field>
         <van-field
          :required="true"
          readonly
          clickable
          name="area"
          :value="model.sysOrgCode_dictText"
          label="所属村庄"
          input-align="right"
          placeholder="请选择"
        />
         <van-field
          v-model="model.address"
          label="详细地址"
          placeholder="--"
          input-align="right"
          readonly
        />
     
    <van-popup v-model="show" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="show = false" value-key="title"/>
    </van-popup>
      </van-form>
    </div>
    <div class="b-btn">
      <button class="b-button"  @click="clickSumbit" >返回</button>
    </div>

   
  </div>
</template>

<script>
import { getAction,putAction} from '@/api/manage'
import uSelect from '@/components/page/u-select.vue'
import { isMobile,isCardID } from '@/utils/validate'
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import { Toast } from 'vant';
export default {
  mixins: [OpenIdMixin], // 使用mixin (在main.js注册全局组件)
  components: {
  	uSelect,
  },
  data() {
    return {
      url: '/system/sysuserwechatbind/edit',
      model: {
      sysOrgCode:'',
      wechatName:'',
      phone:'',
      idNumber:'',
      gzdw:'', //工作单位
      hkdz:'', //户口地址
      xjzdz:'', //现居住地址
      smrzHjqk:'', //户籍情况
      sysOrgCode_dictText:'',
      openId:'',
      },
      sms:'',
      show:false,
      columns:[],
      senMsg_type:1,
      secodes:60,
      myTimer:null,
      sendTxt:"发送验证码",
      isChange:false,
      dhhm:'',
      id:'',
    } 
  },
  created(){
    this.init();
  },
  computed: {
  
  disable(){
    let disable = true;
     if(this.model.wechatName&&this.model.phone&&this.model.idNumber&&this.model.sysOrgCode){
      if(this.isChange){
        if(this.sms){
          disable =false;
        }
      }else{
         disable =false;
      }
     }

    return disable;

  }
  },
 
  methods: {
    onInput(){
       this.isChange = this.dhhm !== this.model.phone;
    },
    init(){
      let obj =  this.getSmrzData();
      this.model = {...obj};
      this.initData();
      // let openId = this.$store.getters.openId
      // let params = { openId: openId }
      // getAction('/system/sysuserwechatbind/get/by/openid', params).then((res) => {
      //     if(res.success){
      //      let obj =  res.result;
      //      if(obj){
      //       this.model.wechatName = obj.wechatName;
      //       this.model.idNumber = obj.idNumber;
      //       this.model.phone = obj.phone;
      //       this.model.sysOrgCode = obj.sysOrgCode;
      //       this.model.id = obj.id;
      //       this.model.address = obj.address;
      //       this.initData();

      //      }
          
      //     }
      // })
    },
    change(index) {
      this.currentTab = index
    },
    initData(){
      let params = {category:'2'}
      getAction('/sys/sysDepart/queryTreeList/by/category/xzzz', params).then((res) => {
          if(res.success){
              let list =  res.result;
              this.columns = list;
              this.model.sysOrgCode_dictText = this.getName(this.columns,this.model.sysOrgCode)
          }
      })

      //    let params = {category:'2'}
      // getAction('sys/sysDepart/queryTreeList/by/category/xzzz', params).then((res) => {
      //     if(res.success){
      //      let list =  res.result;
      //      this.columns = list;
      //      this.model.sysOrgCode_dictText = this.getName(this.columns,this.model.sysOrgCode)
      //     }
      // })
    },
    clickSumbit() {
      this.$router.go(-1);
      // if(!isMobile(this.model.phone)){
      //   this.$toast('请输入正确手机号码');
      //   return;
      // }
      //  this.model.openId = this.$store.getters.openId || "";
      // if(this.isChange){
      //   this.verification();
      // }else{
      //   this.uploadData();
      // }
          
    },
    uploadData(){
          putAction(this.url, this.model).then((res) => {
            if (res.success) {
              this.$router.replace({
                name: 'success',
                params:{
                  isBack:true,
                  title:"实名认证修改成功"
                }
              })

            }
          })
    },
    verification(){
     
      let params = {
        phone:this.model.phone,
        verificationCode:this.sms
      }
      getAction('/sys/mlogin/verify/verification',params).then(res=>{
         if(res.success){
           this.uploadData();
         }
      })
    },
    onConfirm(value,index){
      this.model.sysOrgCode_dictText = value.join('-');
      let index1 = index[0];
      let index2 = index[1];
      let index3 = index[2];
      try {
        let sysOrgCode =  this.columns[index1].children[index2].children[index3].orgCode;
        this.model.sysOrgCode = sysOrgCode;
      } catch (error) {
        
      }
    
     
      this.show =false;
    },
     getName(list,code){
      
      console.log(code);
      let zhenCode = code.substring(0,6);
      let arr = list[0].children.filter(obj=>{
        return obj.orgCode == zhenCode;
      })
     
      let zhenObj = arr[0];
       
      let arr1 = zhenObj.children.filter(obj=>{
        return obj.orgCode == code;
      })
       console.log(arr1);
      let name = zhenObj.title+'-'+arr1[0].title;
      return name;

    },
    sendMsg(){
      if(this.model.phone==""){
        this.$toast('请输入手机号');
        return
      }
      if (!isMobile(this.model.phone)) {
        this.$toast('请输入正确手机号码');
        return;
      }
      let params = {
        sendFlag:true,
        phone:this.model.phone,
      }
      getAction('/sys/mlogin/send/verification',params).then(res=>{
        console.log("res",res);
      })
      this.getSecodes()
    },
    getSecodes(){
      this.secodes = 60
      this.senMsg_type = 2
      this.myTimer = setInterval(()=>{
        this.secodes--
        console.log("倒计时",this.secodes);
        if(this.secodes<=0){
          this.secodes = 0
          this.senMsg_type = 1
          this.sendTxt = "重新获取"
          console.log("清除倒计时");
          clearInterval(this.myTimer)
        }
      },1000)
    }
  },
  beforeDestory(){
    clearInterval(this.myTimer)
  }
}
</script>

<style lang="less" scoped>

.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
}
.u-wrap /deep/ .van-button--primary{
  background-color: #3f8ffb;
  border: 1px solid #3f8ffb;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 12px 8px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 60px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  padding: 0 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
</style>
